import { Validators } from '../../../utils/validators';
import dayjs from 'dayjs';
import { URLS } from 'utils/constants/urls';
import { CountryCode } from 'libphonenumber-js';
import { corporateBookingOptions } from '../../../utils/constants/data';
import { FormModel } from '../../../components/Form';
import { getMinBookingDate } from '../../../utils/validators/HelperFunctions';

export const NewBookingForm = (
  strings: any,
  sources: [],
  eventType: [],
  isDisabled: boolean,
  defaultCountry: CountryCode,
  corporateBooking: 'true' | 'false',
  companyMasterList: any[],
  branchesList: any[],
  contactsList: any[],
  salesManagementEnabled: boolean,
  revenueOwnerList: [],
  pastBookingWindowDays?: number | null,
): any[] => {
  const today = getMinBookingDate(pastBookingWindowDays);
  const arr: FormModel[] = [];
  const noBrowserAutofill = {
    autoComplete: 'new-password',
    'data-1p-ignore': 'true',
    'data-lpignore': 'true',
    'data-form-type': 'other',
  };

  if (salesManagementEnabled) {
    arr.push({
      label: '',
      value: '',
      size: 'medium',
      type: 'toggle-button-group',
      variant: 'outlined',
      placeholder: '',
      field: 'corporateBooking',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      options: corporateBookingOptions(strings),
    });
  }

  if (!salesManagementEnabled || corporateBooking === 'false') {
    arr.push(
      {
        label: strings.new_booking_customer_first_name,
        value: '',
        size: 'medium',
        type: 'autocomplete',
        variant: 'outlined',
        placeholder: '',
        field: 'firstName',
        validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
        url: URLS.regularCustomer,
      },
      {
        label: strings.new_booking_customer_last_name,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'lastName',
        validators: [{ check: Validators.validateString }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: false,
        inputProps: { ...noBrowserAutofill, name: 'bbr-booking-last-name' },
      },
      {
        label: strings.new_booking_customer_phone,
        value: {},
        size: 'medium',
        autoFocus: false,
        type: 'phoneInput',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'phone',
        validators: [{ check: Validators.validateMobile }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: false,
        defaultCountry: defaultCountry,
        inputProps: { ...noBrowserAutofill, name: 'bbr-booking-phone' },
      },
      {
        label: strings.new_booking_customer_email,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'email',
        validators: [{ check: Validators.validateEmail }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: false,
        inputProps: { ...noBrowserAutofill, name: 'bbr-booking-email' },
      },
      {
        label: strings.new_booking_company_name,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'companyName',
        validators: [{ check: Validators.validateString }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: false,
        inputProps: { ...noBrowserAutofill, name: 'bbr-booking-company' },
      },
    );
  } else {
    arr.push(
      {
        label: strings.lead,
        value: '',
        size: 'medium',
        type: 'drop-down',
        variant: 'outlined',
        placeholder: '',
        field: 'companyMaster',
        validators: [{ check: Validators.validateMandatoryField }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
        options: companyMasterList,
      },
      {
        label: strings.sales_company_branch_name,
        value: '',
        size: 'medium',
        type: 'drop-down',
        variant: 'outlined',
        placeholder: '',
        field: 'companyBranch',
        validators: [{ check: Validators.validateMandatoryField }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
        options: branchesList,
        disabled: branchesList.length === 0,
      },
      {
        label: strings.contactedWith,
        value: '',
        size: 'medium',
        type: 'drop-down',
        variant: 'outlined',
        placeholder: '',
        field: 'contactedWith',
        validators: [{ check: Validators.validateMandatoryField }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
        options: contactsList,
        disabled: contactsList.length === 0,
      },
    );
  }
  arr.push(
    {
      label: strings.customermgmt_text_gst,
      value: '',
      size: 'medium',
      type: 'text',
      placeholder: '',
      field: 'gst',
      validators: [{ check: Validators.validateString, max: 20 }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
    {
      label: strings.new_booking_start_date,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'date',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'startDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      minDate: today,
      disabled: isDisabled,
    },
    {
      label: strings.new_booking_end_date,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'date',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'endDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      minDate: today,
      disabled: isDisabled,
    },
    {
      label: strings.source_title_list,
      value: {},
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'agentId',
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: sources,
    },
    {
      label: strings.new_booking_referred_by,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'referredBy',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
    {
      label: strings.new_booking_segment,
      value: {},
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'eventType',
      validators: [{ check: Validators.validateMandatoryField }],
      required: true,
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: eventType,
      disabled: isDisabled,
    },
    // {
    //   label: strings.new_booking_event_sub_type,
    //   value: '',
    //   size: 'medium',
    //   autoFocus: false,
    //   type: 'text',
    //   typeValue: 'text',
    //   variant: 'outlined',
    //   placeholder: '',
    //   field: 'eventSubtype',
    //   validators: [{ check: Validators.validateString }],
    //   responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
    //   required: false,
    // },
    {
      label: strings.customermgmt_text_panNumber,
      value: '',
      size: 'medium',
      type: 'text',
      placeholder: '',
      field: 'panNumber',
      validators: [{ check: Validators.validateString, max: 10 }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
  );
  arr.push({
    label: strings.revenue_owner_title_list,
    value: {},
    size: 'medium',
    type: 'select',
    typeValue: 'text',
    isMulti: true,
    placeholder: '',
    field: 'revenueOwners',
    validators: [],
    required: false,
    responsive: { xs: 12, sm: 6 },
    options: revenueOwnerList,
  });

  return arr;
};
